import React from 'react';

export const DeliveryLogos = ({ variant = 'default' }) => {
  const containerClass = variant === 'hero' 
    ? 'flex items-center justify-center gap-8 my-8'
    : variant === 'footer'
    ? 'flex items-center justify-center gap-8'
    : 'flex items-center justify-center gap-8 my-6';

  return (
    <div className={containerClass}>
      <a
        href="https://www.ubereats.com/fr/store/loriginal/hIHvl2bUT7qqOZiylr7C3w?diningMode=DELIVERY&sc=SEARCH_SUGGESTION"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative transition-all duration-300 hover:transform hover:scale-105"
        aria-label="Commander sur Uber Eats"
      >
        <div className="relative rounded-xl p-4 border-2 border-[#D4A85F]/40 shadow-lg group-hover:border-[#D4A85F] group-hover:shadow-2xl transition-all duration-300">
          <img
            src="https://customer-assets.emergentagent.com/job_de8caf30-ad26-453f-82ca-9c7194fae09f/artifacts/uk5zvv6l_images%20%283%29.png"
            alt="Uber Eats"
            className="h-12 md:h-14 w-auto relative z-10"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#D4A85F]/10 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </div>
      </a>
      <a
        href="https://deliveroo.fr/fr/menu/Paris/palaiseau/loriginal-paris-massy?day=today&geohash=u09t5hss8jyz&time=ASAP"
        target="_blank"
        rel="noopener noreferrer"
        className="group relative transition-all duration-300 hover:transform hover:scale-105"
        aria-label="Commander sur Deliveroo"
      >
        <div className="relative rounded-xl p-4 border-2 border-[#D4A85F]/40 shadow-lg group-hover:border-[#D4A85F] group-hover:shadow-2xl transition-all duration-300">
          <img
            src="https://customer-assets.emergentagent.com/job_de8caf30-ad26-453f-82ca-9c7194fae09f/artifacts/q29dd8ko_Deliveroo-Logo.png"
            alt="Deliveroo"
            className="h-12 md:h-14 w-auto relative z-10"
          />
          <div className="absolute inset-0 bg-gradient-to-br from-[#D4A85F]/10 to-transparent rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
        </div>
      </a>
    </div>
  );
};
